import { CompetitorComparison } from '@/components/CompetitorComparison';
import { useSEO } from '@/hooks/useSEO';

export default function PimberlyComparison() {
  useSEO({
    title: 'Ommni vs Pimberly - PIM Platform Comparison',
    description: 'Compare Ommni and Pimberly. Ommni offers inventory + pricing logic, faster onboarding, and modular licensing vs Pimberly\'s content-focused approach.',
    keywords: 'ommni vs pimberly, pimberly alternative, PIM comparison, product management software',
    canonical: 'https://ommni.io/competitors/pimberly',
  });

  return (
    <CompetitorComparison
      title="Ommni vs Pimberly"
      competitorName="Pimberly"
      competitorUrl="https://pimberly.com/"
      whyOmmni={[
        "Inventory + Pricing Logic: Pimberly excels at content enrichment but lacks first-class support for <a href='/features/inventory'>inventory</a> and <a href='/features/offers'>pricing</a> structures. Ommni handles both natively.",
        "Purpose-Built for Scale: Whether you're launching marketplaces, new brands, or stores — Ommni is optimized for growth across regions and platforms.",
        "Automation Without the Dev Team: Ommni's no-code <a href='/features/ommni-flow'>rules engine</a> and visual editor allow business teams to own product operations without IT bottlenecks.",
        "True SaaS Flexibility: Ommni offers transparent, flexible <a href='/pricing'>pricing</a> with support for AUD & USD billing and modular expansion."
      ]}
      comparisonTable={[
        { feature: "Inventory Support", ommni: true, competitor: false, link: "/features/inventory" },
        { feature: "No-Code Rules Engine", ommni: true, competitor: false, link: "/features/ommni-flow" },
        { feature: "Regional Scalability", ommni: true, competitor: false },
        { feature: "Integration Flexibility", ommni: true, competitor: true, link: "/integrations" },
        { feature: "Retailer/DTC Focus", ommni: true, competitor: false }
      ]}
    />
  );
}
